'use client';

import {
  AudioPlayerProvider,
  useAudioPlayer,
  type AudioPlayer,
} from 'react-use-audio-player';

export { AudioPlayerProvider, useAudioPlayer, type AudioPlayer };
